import React, {Component, useEffect} from "react";
import { Header, Icon, Divider, Form, Label, Container, Select, Button, Segment, Message, Checkbox} from 'semantic-ui-react'
import {requiredField, validateEmail, validateNum} from '../../common/clientValidators'
import {Field, reduxForm, initialize} from 'redux-form'




const RenderInputField = ({input,  label, meta: { touched, error }, ...rest}) =>
    <Form.Field>
        <label>{label}</label>
        <input {...input} {...rest} />
        {touched && error && <Label  basic color='red' pointing>{error}</Label>}
    </Form.Field>


// Admin toggle. Stored server-side as 1/0, so coerce the field value to/from a boolean.
const RenderCheckbox = ({input, label}) =>
    <Form.Field>
        <Checkbox toggle label={label}
                  checked={!!input.value}
                  onChange={(e, { checked }) => input.onChange(checked)}/>
    </Form.Field>



const UserForm = ({error, invalid, handleSubmit, onUpdateValidationState, isAdmin}) => {
    useEffect(() => {
        if (onUpdateValidationState) onUpdateValidationState(invalid)
    }, [invalid])

    return <Form onSubmit={handleSubmit}>
            <Field name='email_user' label="Email" control='input' placeholder='Valid email' component={RenderInputField} validate={[requiredField, validateEmail]} width={5}/>
            <Field name='fullname' label="Full name" control='input' placeholder='Enter full name' component={RenderInputField} width={4} validate={[requiredField]}/>
            <Field name='company' label="Company" control='input' placeholder='Company' component={RenderInputField} width={4} validate={[requiredField]}/>

            {isAdmin &&
                <React.Fragment>
                    <Divider/>
                    <Field name='admin' label='Administrator (can manage users and issue licenses)' component={RenderCheckbox}/>
                </React.Fragment>}

            {error && <Message negative header='Action forbidden' content={error}/> }

        </Form>


}



export default reduxForm({
    form: 'userEditFormRef',
    enableReinitialize : true, // this is needed!!

})(UserForm);
